import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { DxDiagnosisRequestAnswer } from '@src/api/types/dxDiagnosisAnswer';

type CompanyDxDiagnosisAnswerIndexRequest = {
  dx_diagnosis_result_id?: number;
  step_id?: number;
};

export type CompanyDxDiagnosisAnswerIndexResponse = {
  user_id: number;
  is_finished: boolean;
  step: Step;
  questions: Question[];
};

type Step = {
  id: number;
  code: string;
  name: string;
};

type Question = {
  question_id: number;
  question_text: string;
  answer: Answer;
};

type Answer = {
  id: number;
  chosen_text: string;
};

type CompanyDxDiagnosisAnswerCreateResponse = unknown;
type CompanyDxDiagnosisAnswerCreateErrorResponse = {
  dx_diagnosis_question_id: string[];
  dx_diagnosis_choice_id: string[];
  dx_diagnosis_result_id: string[];
};

export const companyDxDiagnosisAnswerApiClient = {
  index: async (
    params: CompanyDxDiagnosisAnswerIndexRequest = {},
  ): Promise<ApiResult<CompanyDxDiagnosisAnswerIndexResponse[]>> => {
    return await axiosClient.get('/company/dx-diagnosis-answers', { params });
  },
  create: async (
    data: DxDiagnosisRequestAnswer[],
  ): Promise<
    ApiResult<CompanyDxDiagnosisAnswerCreateResponse, CompanyDxDiagnosisAnswerCreateErrorResponse>
  > => {
    return await axiosClient.post('/company/dx-diagnosis-answers', data);
  },
};
